import { createTheme } from "@mantine/core";

export const mantineTheme = createTheme({
  colors: {
    secondary: [
      "#fff5f5", // [0] 아주 밝은 핑크
      "#ffe3e3", // [1]
      "#ffc9c9", // [2]
      "#ffa8a8", // [3]
      "#ff8787", // [4]
      "#fc5f64", // [5] 기준색
      "#e64954", // [6]
      "#d6334f", // [7]
      "#c22545", // [8]
      "#a61e4d", // [9] 가장 어두운 레드/핑크 계열
    ],
    primary: [
      "#f4f4f4", // [0] 거의 흰색에 가까운 밝은 회색
      "#e0e0e0", // [1]
      "#c2c2c2", // [2]
      "#a3a3a3", // [3]
      "#7c7c7c", // [4]
      "#353535", // [5] 기준색
      "#2f2f2f", // [6]
      "#282828", // [7]
      "#1f1f1f", // [8]
      "#141414", // [9] 거의 블랙
    ],
    success: [
      "#F5FCF8",
      "#E8F8EF",
      "#D1F2E1",
      "#BAE9D4",
      "#A3E1C7",
      "#2ECC71", // 5: 메인 Success Color
      "#27AE60",
      "#219A52",
      "#1A864C",
      "#146F3E",
    ],
    neutral: [
      "#E6F0FF",
      "#CCE0FF",
      "#99C2FF",
      "#66A3FF",
      "#3385FF",
      "#0056B3", // 5: 메인 Primary Accent
      "#004A99",
      "#003F80",
      "#00264D",
      "#001A33",
    ],
  },
  primaryColor: "primary",
  primaryShade: 5,
  components: {
    Button: {
      styles: {
        root: {
          borderRadius: 0,
        },
      },
    },
    Table: {
      defaultProps: {
        withTableBorder: true,
        highlightOnHover: true,
      },
      styles: {
        tbody: {
          tr: {
            "&:hover": {
              backgroundColor: "#fafafa",
            },
          },
        },
        th: {
          textAlign: "center",
          // backgroundColor: '#f6eeff',
        },
        td: {
          textAlign: "center",
        },
      },
    },
    Select: {
      styles: {
        input: {
          borderRadius: 0,
        },
        dropdown: {
          borderRadius: 0,
        },
      },
    },
    TextInput: {
      styles: {
        input: {
          borderRadius: 0,
        },
      },
    },
    Textarea: {
      styles: {
        input: {
          borderRadius: 0,
        },
      },
    },
    Pagination: {
      defaultProps: {
        size: "sm",
      },
    },
    DateInput: {
      styles: {
        input: {
          borderRadius: 0,
        },
      },
    },
    FileInput: {
      styles: {
        input: {
          borderRadius: 0,
        },
      },
    },
    Modal: {
      styles: {
        header: {
          borderBottom: "1px solid #e0e0e0",
          marginBottom: "16px",
        },
      },
    },
    Switch: {
      styles: {
        track: {
          cursor: "pointer",
        },
      },
    },
  },
});
